import React, {useEffect, useState} from "react";
import {Col, Nav, Row} from "react-bootstrap";
import axios from "axios";
import {Link, useParams} from "react-router-dom";
import Moment from 'moment'
import {useSelector} from "react-redux";

// TODO: the refresh needs a timer on it. Otherwise it just runs all the time


const InspectionsDash = () => {
    Moment.locale('en');
    const [info, setInfo] = useState()

    const {id} = useParams();
    const userLogin = useSelector(state => state.userLogin)
    const {userInfo} = userLogin

    const loadClients = async () => {
        const {data} = await axios.get(`https://homesafetysolutions.pythonanywhere.com/api/client_inspections_dash/`, {
        // const {data} = await axios.get(`http://127.0.0.1:8000/api/client_inspections_dash/`, {
            headers: {
                'Content-type': 'application/json',
                Authorization: `Bearer ${userInfo.token}`
            }
        })
        setInfo(data)
    }

    useEffect(() => {
        loadClients()
    }, []);

    let redirect = ''
    if (userInfo){
        if (userInfo.group === "AdminSuper"){
            redirect = '/active_work_orders'
        } else if (userInfo.group === "Tech") {
            redirect = '/tech_work_orders'
        }
    }

    return (
        <div>
            <Nav variant="tabs" defaultActiveKey="/active_work_orders" className={'reports_nav_heading'}>
                <Nav.Item>
                    <Nav.Link href="#/active_work_orders">Active Work Orders</Nav.Link>
                </Nav.Item>
                <Nav.Link href={'#/priority_reports'} >
                    Active Priority Tasks
                </Nav.Link>
                <Nav.Link href={'#/done_priority_reports'}>
                    Inactive Priority Tasks
                </Nav.Link>
                <Nav.Link href={'#/inspections_dash/'} eventKey="disabled" disabled>
                    Inspections Dash
                </Nav.Link>
            </Nav>

            <Link style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                marginTop:'5px'
            }} className={'btn btn-primary'} to={redirect}>Active Work Orders Dashboard</Link>

            <br /><br />

            {info?.map(item =>
                <Row className={'HourPerRow'} key={item.created}>
                    <Col>
                        <h4>Address: {item.work_site_address}</h4>
                        <h4>Project ID: {item.project_ID}</h4>
                    </Col>
                    <Col>
                        <Link
                            style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            // marginTop:'5px'
                        }}
                            className={'btn btn-outline-danger'}
                            to={`/clients/${item.id}/add_monthly_inspection/`}
                        >
                            Add Monthly Inspection
                        </Link>
                    </Col>
                    <Col>
                        <Link className={'btn btn-info'} to={`/monthly_inspections/${item.id}/`}>
                            Inspections
                        </Link>
                    </Col>
                    {/*<Col>*/}
                        {/*<h5>Quarterly Inspection Going Here</h5>*/}
                        {/*<Link*/}
                        {/*    className={'btn btn-warning disable-link'}*/}
                        {/*    to={`/quarterly_inspection_initiations/${item.id}/`}*/}
                        {/*>*/}
                        {/*    Quarterly Inspection*/}
                        {/*</Link>*/}
                    {/*</Col>*/}
                </Row>
            )}
        </div>
    );

}
export default InspectionsDash;
